export function roundToDP(value: number, dp: number = 2): number {
  const places = Math.pow(10, dp)
  let rounded = dp > 0 ? Math.round((value + Number.EPSILON) * places) / places : Math.round(value)
  return rounded
}

export function pctChange(a: number, b: number): number {
  // Handle division by zero - no change if previous value is 0
  if (b === 0) return 0

  const increase = a >= b
  let value = Math.floor((increase ? (a - b) / b : (b - a) / b) * 1000) / 10
  if (!increase) value *= -1
  return value
}
